var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "popup",
      attrs: { "aria-modal": "true", role: "dialog", transition: "modal" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.closePopup.apply(null, arguments)
        },
      },
    },
    [
      _c("span", {
        staticClass: "popup__overlay",
        on: { click: _vm.closePopup },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "popup__wrapper theme--white" }, [
        _c("div", {
          attrs: { tabindex: "0" },
          on: {
            focus: function ($event) {
              $event.preventDefault()
              return _vm.focusLast.apply(null, arguments)
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "first",
            staticClass: "popup__close",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.closePopup.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "sr-only" }, [_vm._v(_vm._s(_vm.close))]),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 16 15.983",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M1.772 0A1.774 1.774 0 00.537 3.046L5.491 8 .537 12.955a1.774 1.774 0 102.509 2.509L8 10.509l4.954 4.954a1.774 1.774 0 102.509-2.509L10.508 8l4.954-4.954A1.774 1.774 0 1012.954.538L7.999 5.492 3.045.537A1.774 1.774 0 001.772 0z",
                  },
                }),
              ]
            ),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "popup__content" }, [
          _c("strong", { staticClass: "popup__title" }, [
            _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
          ]),
          _vm._v(" "),
          _vm.desc
            ? _c("div", { staticClass: "popup__desc" }, [
                _vm._v("\n        " + _vm._s(_vm.desc) + "\n      "),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "popup__options" }, [
          _c(
            "button",
            { staticClass: "btn btn--black", on: { click: _vm.previousPage } },
            [
              _c("span", { staticClass: "btn__content" }, [
                _c("span", { staticClass: "btn__text" }, [
                  _vm._v(_vm._s(_vm.back)),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              ref: "last",
              staticClass: "btn btn--black",
              on: { click: _vm.closePopup },
            },
            [
              _c("span", { staticClass: "btn__content" }, [
                _c("span", { staticClass: "btn__text" }, [
                  _vm._v(_vm._s(_vm.close)),
                ]),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c("div", { attrs: { tabindex: "0" }, on: { focus: _vm.focusFirst } }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }